import { Eye } from 'lucide-react';
import { Control, useWatch } from 'react-hook-form';
import { BillingTermMetaResponseDto } from '../../../products/types/response';
import { toOfferPreviewData } from '../../lib/preview';
import { OfferFormOptionsResponseDto, OfferMetaResponseDto } from '../../types/response';
import { OfferFormValues } from '../offer-form/offer-form.schema';
import OfferPreviewFrame from '../offer-preview-frame/offer-preview-frame';

export interface OfferPreviewProps {
  control: Control<OfferFormValues>;
  options: OfferFormOptionsResponseDto;
  billingTerms: BillingTermMetaResponseDto[];
  meta: OfferMetaResponseDto;
  /** The PDF the offer will have after saving. */
  offerFileName: string | null;
}

/** Live preview of the checkout for the current form values. */
const OfferPreview = ({ control, options, billingTerms, meta, offerFileName }: OfferPreviewProps) => {
  const values = useWatch({ control });

  const product = options.products.find((option) => option._id === values.productId);
  const termMeta = billingTerms.find((billingTerm) => billingTerm.term === values.term);
  const preview = product && termMeta ? toOfferPreviewData(values, product, termMeta.term, options.addOns, meta, offerFileName) : null;

  return (
    <aside aria-label="Live-Vorschau" className="sticky top-5 flex flex-col gap-2">
      <span className="flex items-center gap-2 text-[14px] font-bold text-[#12282A]">
        <Eye className="h-4 w-4" />
        Live-Vorschau
      </span>
      <OfferPreviewFrame preview={preview} termMonths={termMeta?.months ?? null} placeholder="Ausgewählte Laufzeit und Produkt benötigt…" />
    </aside>
  );
};

export default OfferPreview;
